import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { CssBaseline } from '@mui/material'
import { StytchProvider } from '@stytch/react'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.jsx'
import { ThemeProvider } from './context/ThemeContext.jsx'
import { AuthProvider } from './context/AuthContext.jsx'
import { stytch } from './config/stytch.js'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <StytchProvider stytch={stytch}>
        <BrowserRouter>
          <AuthProvider>
            <ThemeProvider>
              <CssBaseline />
              <App />
            </ThemeProvider>
          </AuthProvider>
        </BrowserRouter>
      </StytchProvider>
    </HelmetProvider>
  </React.StrictMode>
)
